<template>
    <div>
      <!-- <span>{{ type }}</span> -->
      <template v-if="type==='bi'">
        <i class="bi" :class="`bi-${name}`"></i>
      </template>
      <template v-if="type==='coreui'">
        <CIcon :name="`cil-${name}`"></CIcon>
      </template>
    </div>
</template>
<script>
export default {
  name: 'BCIcon',
  props: {
    type: {
      type: String,
      default: "bi"
    },
    name: {
      type: String,
      default: ""
    }
  }
}
</script>